<div class="ui container" appMargin appPadding paddingB="30">
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutGap="20px" (click)="goBack()" class="link">
        <div>
          <img src="assets/icons/left-arrow-icon.svg" alt="" />
        </div>
        <div class="equipment-id">
          <!-- Title -->
          <label class="ui grey">Home / Company Details</label>
          <h2 class="ui primary header">Company Details</h2>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px"></div>
    </div>
    <div class="ui divider" appMargin marginY="3"></div>
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="30px">
    <div
      fxFlex="20%"
      fxLayout="column"
      fxLayoutGap="10px"
      *ngIf="!isRestrictedEntity"
    >
      <div class="side-panel">
        <a
          *ngFor="let link of projectFields"
          class="ui white button project-field"
          routerLink="/contractor/company/{{ link.route }}"
          routerLinkActive="primary"
          [queryParams]="{
            typeId: link.type,
            typeName: link.type ? link.name : null
          }"
          appMargin
          marginY="8px"
          appPadding
          paddingY="14px"
        >
          {{
            link?.isTitleCase ? (link?.name | titlecase | plural) : link?.name
          }}
        </a>
      </div>
    </div>
    <div style="margin-left: -1rem;" fxFlex="grow">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
